export default __webpack_public_path__ + "static/media/FollowUp.2040d471.svg";